/**
 * Returns API data from endpoint
 * @param {string} url - API endpoint string
 * @returns {object} - Data from the endpoint"
 */
export async function getRequest(url) {
  try{
    const response = await fetch(url);
    if(response.status === 200) {
    const data = await response.json();
      // console.log("Success:",response,data);
      return data;
    } else{
      console.log("Server Error",response)
    }
  } catch(error){
    console.log("Error", error);
  }
}

/**
 * Formats a date to "MM/dd/yyyy h:mm tt" format
 * @param {string|Date} dateValue - Input date string or Date object
 * @returns {string} - Formatted date string like "01/01/2025 12:01 PM"
 */
export function formatDateTimeInvariant(dateValue) {
    const date = new Date(dateValue);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${month}/${day}/${year} ${hours}:${minutes} ${ampm}`;
}

/**
 * Formats a date to "MM/dd/yyyy" format
 * @param {string|Date} dateValue - Input date string or Date object
 * @returns {string} - Formatted date string like "01/01/2025"
 */
export function formatDateInvariant(dateValue) {
    const date = new Date(dateValue);
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
}